import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWithRedux from './views/App/Redux';
import './styles/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithRedux />
  </React.StrictMode>
);
